import React from 'react';
import './FormInput.css';

const PersonaInput = ({ value, onChange }) => {
  return (
    <div className="form-input-group">
      <label className="form-label">Persona</label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="form-textarea"
        placeholder="e.g., a marketing strategist"
        rows="4"
      />
    </div>
  );
};

export default PersonaInput;

